
// THIS FILE IS AUTOGENERATED AS PART OF THE EXTENSION AND MODE PLUGIN PROCESS.
// IT SHOULD NOT BE MODIFIED MANUALLY 
const extensions = [];
const modes = [];

// Not required any longer
window.extensions = extensions;
window.modes = modes;

extensions.push("@alm/extension-default");
extensions.push("@alm/extension-cornerstone");
modes.push("@alm/mode-longitudinal");
modes.push("@alm/mode-segmentation");
modes.push("@alm/mode-tmtv");
modes.push("@alm/mode-microscopy");
modes.push("@alm/mode-preclinical-4d");


// Add a dynamic runtime loader
async function loadModule(module) {
  if (typeof module !== 'string') return module;
  if( module==="@alm/extension-default") {
    const imported = await import("@alm/extension-default");
    return imported.default;
  }
  if( module==="@alm/extension-cornerstone") {
    const imported = await import("@alm/extension-cornerstone");
    return imported.default;
  }
  if( module==="@alm/extension-measurement-tracking") {
    const imported = await import("@alm/extension-measurement-tracking");
    return imported.default;
  }
  if( module==="@alm/extension-cornerstone-dicom-sr") {
    const imported = await import("@alm/extension-cornerstone-dicom-sr");
    return imported.default;
  }
  if( module==="@alm/extension-cornerstone-dicom-seg") {
    const imported = await import("@alm/extension-cornerstone-dicom-seg");
    return imported.default;
  }
  if( module==="@alm/extension-cornerstone-dynamic-volume") {
    const imported = await import("@alm/extension-cornerstone-dynamic-volume");
    return imported.default;
  }
  if( module==="@alm/extension-dicom-microscopy") {
    const imported = await import("@alm/extension-dicom-microscopy");
    return imported.default;
  }
  if( module==="@alm/extension-dicom-pdf") {
    const imported = await import("@alm/extension-dicom-pdf");
    return imported.default;
  }
  if( module==="@alm/extension-dicom-video") {
    const imported = await import("@alm/extension-dicom-video");
    return imported.default;
  }
  if( module==="@alm/extension-tmtv") {
    const imported = await import("@alm/extension-tmtv");
    return imported.default;
  }
  if( module==="@alm/extension-test") {
    const imported = await import("@alm/extension-test");
    return imported.default;
  }
  if( module==="@alm/extension-cornerstone-dicom-rt") {
    const imported = await import("@alm/extension-cornerstone-dicom-rt");
    return imported.default;
  }
  if( module==="@alm/mode-longitudinal") {
    const imported = await import("@alm/mode-longitudinal");
    return imported.default;
  }
  if( module==="@alm/mode-segmentation") {
    const imported = await import("@alm/mode-segmentation");
    return imported.default;
  }
  if( module==="@alm/mode-tmtv") {
    const imported = await import("@alm/mode-tmtv");
    return imported.default;
  }
  if( module==="@alm/mode-microscopy") {
    const imported = await import("@alm/mode-microscopy");
    return imported.default;
  }
  if( module==="@alm/mode-preclinical-4d") {
    const imported = await import("@alm/mode-preclinical-4d");
    return imported.default;
  }
  if( module==="@alm/mode-test") {
    const imported = await import("@alm/mode-test");
    return imported.default;
  }
  if( module==="@alm/mode-basic-dev-mode") {
    const imported = await import("@alm/mode-basic-dev-mode");
    return imported.default;
  }
  return (await import(/* webpackIgnore: true */ module)).default;
}

// Import a list of items (modules or string names)
// @return a Promise evaluating to a list of modules
export default function importItems(modules) {
  return Promise.all(modules.map(loadModule));
}

export { loadModule, modes, extensions, importItems };

